import { Box } from "@mui/material";
import { BG_WHITE, BORDER, RADIUS_CARD, CARD_SHADOW, DIVIDER, cardLabelSx } from "./bentoTokens";

// Generic white rounded "bento" card. Pass `title`/`headerRight` for the divider-separated
// header row used throughout scenes/financial (e.g. OutstandingCard); omit both for a plain
// padded card.
const BentoCard = ({ title, headerRight, children, sx, bodySx, radius = RADIUS_CARD, ...rest }) => {
  const hasHeader = Boolean(title || headerRight);
  return (
    <Box
      sx={{
        background: BG_WHITE,
        border: `1px solid ${BORDER}`,
        borderRadius: radius,
        boxShadow: CARD_SHADOW,
        overflow: "hidden",
        ...sx,
      }}
      {...rest}
    >
      {hasHeader && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "12px",
            p: "20px 24px",
            borderBottom: `1px solid ${DIVIDER}`,
          }}
        >
          {title && <Box sx={cardLabelSx}>{title}</Box>}
          {headerRight}
        </Box>
      )}
      <Box sx={{ p: hasHeader ? 0 : "22px", ...bodySx }}>{children}</Box>
    </Box>
  );
};

export default BentoCard;
